import "./styles/styles.css";
// Needed to auto register the charts
import Chart from 'chart.js/auto';

import React, {useContext, useEffect} from "react";
import {Dashboard} from "./views/dashboard";
import {AuthContext} from "./context/authContext";
import {Welcome} from "./views/welcome";


function App() {
    const {currentUser, isLoggedIn, login, logout} = useContext(AuthContext);

    return (
        <div>
            {isLoggedIn ? <Dashboard/> : <Welcome/>}
        </div>
    );
}

export default App;
